import { createI18n } from 'vue-i18n'

import en from './en'
import zhCN from './zh-CN'
import { LOCALE_STORAGE_KEY } from '@/config/brand'

export type AppLocale = 'zh-CN' | 'en'

export const SUPPORTED_LOCALES: AppLocale[] = ['zh-CN', 'en']
export function detectInitialLocale(): AppLocale {
  if (typeof window === 'undefined' || !window.localStorage) return 'zh-CN'
  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored === 'en' || stored === 'zh-CN') return stored
  } catch {
    // localStorage may be unavailable (private mode / test env) — fall back to default.
  }
  return 'zh-CN'
}

export function persistLocale(locale: AppLocale): void {
  if (typeof window === 'undefined' || !window.localStorage) return
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch {
    // Ignore storage failures (quota / private mode).
  }
}

export function setAppLocale(locale: AppLocale): void {
  i18n.global.locale.value = locale
  persistLocale(locale)
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale === 'en' ? 'en' : 'zh-CN'
  }
}

export const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: 'zh-CN',
  messages: { 'zh-CN': zhCN, en },
})

// Sync <html lang> on init.
if (typeof document !== 'undefined') {
  document.documentElement.lang = detectInitialLocale() === 'en' ? 'en' : 'zh-CN'
}
